export const environment = {
    production: true,
    apiUrl: 'https://api.cncdental.eu',
    mercureHub: 'https://api.cncdental.eu/hub/.well-known/mercure',
    uploaderUrl: 'https://api.cncdental.eu/archivos',
    // apiUrl: 'https://cnc-api.nedaware.eu',
    // uploaderUrl: 'https://cnc-api.nedaware.eu/archivos',
    // mercureHub: 'https://cnc-api.nedaware.eu/hub/.well-known/mercure',
    version: 'v2.3'
};
